/**
 * @author: dongjing
 * @file: 提问分页数据列表（圈子，团队，标签页面）
 * @Date: 2020-01-06 19:05:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 14:59:52
 */
import React from 'react';
import * as models from '@src/services/model/models';
import './TabAskList.less';
import { SFCQuestionTextImage, SFCPagination, NoData } from '..';
import { Spin } from 'antd';

export interface ITabAskListProps {
  /** 加载状态 */
  loading: boolean;
  /** 提问数据 */
  askModel: models.PageableResultSingleArticleInfo;
  /** 关注取关 */
  toggleFollow: (data: models.QuestionSimpleInfo) => void;
  /** 页码切换 */
  changePage: (pageNum: number) => void;
  /** 页面打开方式函数 */
  enableTargetBlank?: boolean;
  /** 是否能编辑删除 */
  canEdit?: boolean;
  /** 删除问题 */
  removeQuestion?: (item: models.QuestionSimpleInfo) => void;
  /** 是否需要置顶 */
  pinned?: boolean;
  /** 是否是管理员 */
  isAdmin?: boolean;
  /** 置顶函数 */
  stickyAsk?: (stickType: number, articleOrQuestionId: number, type: number) => void;
}
type Props = ITabAskListProps;
const PAGE_SIZE = 10;
export function TabAskList(props: Readonly<Props>) {
  const {
    loading,
    askModel,
    toggleFollow,
    changePage,
    canEdit = false,
    removeQuestion,
    enableTargetBlank = false,
    pinned = false,
    isAdmin = false,
    stickyAsk
  } = props;

  /** 页码切换 */
  const changePageNum = (pageNum: number) => {
    changePage(pageNum);
  };

  /** 关注切换 */
  const onFollow = (data: models.QuestionSimpleInfo) => {
    toggleFollow(data);
  };

  /** 提问置顶 */
  const askSticky = (stickType: number, articleOrQuestionId: number) => {
    stickyAsk && stickyAsk(stickType, articleOrQuestionId, 2);
  };
  return (
    <div className="common-presenter k-common-tab-ask-list">
      <Spin className="common-presenter k-circle-ask-list" spinning={loading}>
        {askModel.list &&
          askModel.list.map((item, index) => {
            item[`isFollowing`] = item[`isFollowing`] || false;
            return (
              <SFCQuestionTextImage
                data={item}
                index={index}
                onFollow={() => {
                  onFollow(item);
                }}
                key={`qus${index}`}
                showOption={canEdit}
                handleRemove={() => {
                  removeQuestion && removeQuestion(item);
                }}
                enableTargetBlank={enableTargetBlank}
                pinned={pinned}
                isAdmin={isAdmin}
                askSticky={askSticky}
              />
            );
          })}
        {askModel.list && askModel.list.length > 0 ? (
          <SFCPagination
            pageNum={askModel.pageNum || 1}
            pageSize={askModel.pageSize || PAGE_SIZE}
            total={askModel.total || 0}
            onChange={changePageNum}
          />
        ) : (
          <NoData show={true} />
        )}
      </Spin>
    </div>
  );
}

export default TabAskList;
